import { grey } from "@material-ui/core/colors";
import { Box, Stack, Typography } from "@mui/material";
import React from "react";
// import DotLoader from 'react-spinners/DotLoader';
import { LiquidLoader, UserLoader } from "../lottie";

// const override = `
//     display: block;
//     margin: 17% 50%;
// `;

const Preloader = ({ height, width, module }) => {
  const loader = React.useCallback(() => {
    switch (module) {
      case "calendar":
        return (
          <Stack>
            <UserLoader height={150} width={150} loop={true} />
            <Typography
              variant="h6"
              sx={{ color: grey[500], textAlign: "center" }}
            >
              Groups/Users Loading...
            </Typography>
          </Stack>
        );

      default:
        return (
          <Stack>
            <LiquidLoader
              height={height ?? 180}
              width={width ?? 180}
              loop={true}
            />
            <Typography sx={{ opacity: 0.9, textAlign: "center" }}>
              Loading...
            </Typography>
          </Stack>
        );
    }
  }, [module, height, width]);
  return (
    <Box
      sx={{
        minHeight: "80%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "100%",
      }}
    >
      {loader(module)}
    </Box>
  );
};

export default Preloader;
